import React, { Component } from 'react';

class AuthPasswordReset extends Component {
  render() {
    return <div>Hello Password Reset</div>;
  }
}

export default AuthPasswordReset;
